module.exports = __webpack_public_path__ + "media/assets/images/claim-places/button-delete-icon-7f3a4c39a154f23e8b32106a91a6d9e2.svg";